<template>
  <div>
  <div class="content">
    <div class="container">
      <form method="post"
            action="#"
            class="form form--register">
        <header-lang-selector />
        <h1 v-word:layout.userData1.mainHeader />
        <div class="form__logo">
          <div id="logo" />
        </div>
        <div class="form__section"
             v-word:layout.userData1.intro />
        <section class="form__section">

          <input-text label-word="layout.userData1.internal_email.label"
                      hint-word="layout.userData1.internal_email.hint"
                      :wordings-editable="wordingsEditable"
                      :data="formData.internal_email"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.date.first_day.label"
                      hint-word="layout.userData1.date.first_day.hint"
                      :wordings-editable="wordingsEditable"
                      :data="formData.first_day"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.date.deadline.label"
                      hint-word="layout.userData1.date.deadline.hint"
                      :wordings-editable="wordingsEditable"
                      :data="formData.deadline"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          </section>
          <section class="form__section">
            <h2 v-word:layout.userData1.personal.title />

            <input-radio :data="formData.salutation"
                         :wordings="wordings"
                         label-word="layout.userData1.personal.salutation.label"
                         :wordings-editable="wordingsEditable"
                         :wordings-meta="wordingsMeta"
                         @change="inputChanged"
                         @wordingChange="onWordingChange"
                         @wordingCommand="runWordingCommand"
                         :opts="[{
                          titleWord: 'layout.userData1.personal.mr',
                          val: 'Herr'
                        }, {
                          titleWord: 'layout.userData1.personal.mrs',
                          val: 'Frau'
                        }]" />

            <input-text label-word="layout.userData1.personal.name.label"
                        hint-word="layout.userData1.personal.name.hint"
                        :wordings-editable="wordingsEditable"
                        :wordings="wordings"
                        :wordings-meta="wordingsMeta"
                        :data="formData.firstname"
                        @change="inputChanged"
                        @wordingChange="onWordingChange"
                        @wordingCommand="runWordingCommand"
                        :enablePlaceholder="!wordingsEditable" />

            <input-text label-word="layout.userData1.personal.surname.label"
                        hint-word="layout.userData1.personal.surname.hint"
                        :wordings-editable="wordingsEditable"
                        :wordings="wordings"
                        :wordings-meta="wordingsMeta"
                        :data="formData.surname"
                        @change="inputChanged"
                        @wordingChange="onWordingChange"
                        @wordingCommand="runWordingCommand"
                        :enablePlaceholder="!wordingsEditable" />

            <input-text label-word="layout.userData1.personal.email.label"
                        hint-word="layout.userData1.personal.email.hint"
                        :wordings-editable="wordingsEditable"
                        :data="formData.email"
                        :wordings="wordings"
                        :wordings-meta="wordingsMeta"
                        @change="inputChanged"
                        @wordingChange="onWordingChange"
                        @wordingCommand="runWordingCommand"
                        :enablePlaceholder="!wordingsEditable" />

            <input-text label-word="layout.userData1.personal.phone.label"
                        hint-word="layout.userData1.personal.phone.hint"
                        :wordings-editable="wordingsEditable"
                        :data="formData.phone"
                        :wordings="wordings"
                        :wordings-meta="wordingsMeta"
                        @change="inputChanged"
                        @wordingChange="onWordingChange"
                        @wordingCommand="runWordingCommand"
                        :enablePlaceholder="!wordingsEditable" />

            <language-select label-word="layout.userData1.personal.language.label"
                            :wordings-editable="wordingsEditable"
                            :wordings="wordings"
                            :wordings-meta="wordingsMeta"
                            :data="formData.language"
                             :loadedLanguages="loadedLanguages"
                            @change="inputChanged"
                            @wordingChange="onWordingChange"
                            @wordingCommand="runWordingCommand" />
          </section>


        <section class="form__section">
        <h2 v-word:layout.userData1.company.title />

        <input-text label-word="layout.userData1.company.name.label"
                    hint-word="layout.userData1.company.name.hint"
                    :wordings-editable="wordingsEditable"
                    :wordings="wordings"
                    :wordings-meta="wordingsMeta"
                    :data="formData.company"
                    @change="inputChanged"
                    @wordingChange="onWordingChange"
                    @wordingCommand="runWordingCommand"
                    :enablePlaceholder="!wordingsEditable" />

        <input-text label-word="layout.userData1.company.street.label"
                    hint-word="layout.userData1.company.street.hint"
                    :wordings-editable="wordingsEditable"
                    :wordings="wordings"
                    :wordings-meta="wordingsMeta"
                    :data="formData.company_street"
                    @change="inputChanged"
                    @wordingChange="onWordingChange"
                    @wordingCommand="runWordingCommand"
                    :enablePlaceholder="!wordingsEditable" />

        <input-text label-word="layout.userData1.company.zip_code.label"
                    hint-word="layout.userData1.company.zip_code.hint"
                    :wordings-editable="wordingsEditable"
                    :wordings="wordings"
                    :wordings-meta="wordingsMeta"
                    :data="formData.company_zip_code"
                    @change="inputChanged"
                    @wordingChange="onWordingChange"
                    @wordingCommand="runWordingCommand"
                    :enablePlaceholder="!wordingsEditable" />

        <input-text label-word="layout.userData1.company.town.label"
                    hint-word="layout.userData1.company.town.hint"
                    :wordings-editable="wordingsEditable"
                    :wordings="wordings"
                    :wordings-meta="wordingsMeta"
                    :data="formData.company_town"
                    @change="inputChanged"
                    @wordingChange="onWordingChange"
                    @wordingCommand="runWordingCommand"
                    :enablePlaceholder="!wordingsEditable" />

        </section>

        <section class="form__section">
          <h2 v-word:layout.userData1.contact.title />
          <h3 style="text-align: center" v-word:layout.userData1.contact.subtitle />

          <input-text label-word="layout.userData1.contact.firstname.label"
                      hint-word="layout.userData1.contact.firstname.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.contact_firstname"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.contact.surname.label"
                      hint-word="layout.userData1.contact.surname.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.contact_surname"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.contact.email.label"
                      hint-word="layout.userData1.contact.email.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.contact_email"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

          <input-text label-word="layout.userData1.contact.phone.label"
                      hint-word="layout.userData1.contact.phone.hint"
                      :wordings-editable="wordingsEditable"
                      :wordings="wordings"
                      :wordings-meta="wordingsMeta"
                      :data="formData.contact_phone"
                      @change="inputChanged"
                      @wordingChange="onWordingChange"
                      @wordingCommand="runWordingCommand"
                      :enablePlaceholder="!wordingsEditable" />

        </section>

        <section class="form__section">

          <div class="etask_logo"></div>

          <a href="images/DE_PrivacyPolicy_webForm_eTASK.pdf" v-word:layout.registration.terms />

          <br style="clear: both">

          <a class="privacy-policy-link"
             target="_blank"
             :href="!editMode && $router.resolve({ name: 'agb' }).href"
             v-word:layout.userData1.links.readPolicy />

          <input-checkbox label-word="layout.userData1.dataAccepted.label"
                          :wordings-editable="wordingsEditable"
                          :wordings="wordings"
                          :wordings-meta="wordingsMeta"
                          @wordingChange="onWordingChange"
                          @wordingCommand="runWordingCommand"
                          :data="formData.data_accepted"
                          @change="inputChanged"
                          class="form__input--checkbox--agree"
                          downloadLink="not existent yet" />

          <div class="form__input form__input--checkbox form__input--checkbox--agree">

            <input-checkbox label-word="layout.userData1.tosAccepted.label"
                            :wordings-editable="wordingsEditable"
                            :wordings="wordings"
                            :wordings-meta="wordingsMeta"
                            @wordingChange="onWordingChange"
                            @wordingCommand="runWordingCommand"
                            :data="formData.tos_accepted"
                            @change="inputChanged"
                            class="form__input--checkbox--agree"
                            downloadLink="not existent yet" />

          </div>
        </section>

        <section class="form__section">
          <div class="form__input form__input--checkbox">
            <div class="form__input__wrap">
              <label></label>
              <captcha ref="captcha"
                       @verify="token => this.formData.captcha.val = token" />
            </div>
            <p v-show="formData.captcha.error"
               class="form__error"
               v-word:validation.errors.required></p>
          </div>
        </section>
        <section class="form__section">
          <div class="form__input form__input--submit">
            <button type="submit"
                    @click.prevent="submit"
                    v-word:layout.userData1.buttons.submit />
          </div>
        </section>
      </form>
    </div>
  </div>
  <pageFooter />
  </div>
</template>

<script>
import config from 'config';
import * as forms from '../utils/forms';
import * as mixins from '../mixins';
import LanguageSelect from '../components/LanguageSelect';
import languagesStore from '../models/languages.js';
import backendConfig from '../utils/backendConfig';
import Captcha from 'ref-captcha';
import { errorToHumanString } from '../utils/validation';
import footer from '../layout/Footer';

const formDataDef = {
  internal_email: { '*': 1 },
  first_day: { '*': 1 },
  deadline: { '*': 1 },
  salutation: { '*': 1 },
  firstname: { '*': 1 },
  surname: { '*': 1 },
  email: { '*': 1 },
  phone: { '*': 1 },
  language: { '*': 1 },
  company: { '*': 1 },
  company_street: { '*': 1 },
  company_zip_code: { '*': 1 },
  company_town: { '*': 1 },
  contact_surname: { '*': 1 },
  contact_firstname: { '*': 1 },
  contact_email: { '*': 1 },
  contact_phone: { '*': 1 },
  data_accepted: { '*': 1 },
  tos_accepted: { '*': 1 },
  captcha: { '*': 0 },
};

export const storageName = 'userData1';

export default {
  props: ['autoSubmit'],
  mixins: [mixins.wordedPage, mixins.form, mixins.langSelector],
  components: {LanguageSelect, pageFooter: footer, Captcha},
  data() {
    return {
      formDataDef: formDataDef,
      formStorageName: storageName,
      loadedLanguages: [],
    };
  },
  created() {
    if (this.autoSubmit) {
      this.submit();
      this.$emit('noAutoSubmit');
    }

    languagesStore.fetchAll().then(languages => {
      this.loadedLanguages = languages;
    });
  },
  methods: {
    submit() {
      const formData = forms.marshal(this.formData);
      let formErrors = {};
      this.$emit('loading');
      backendConfig.get().then(({backendUrl}) => {
        this.$http
          .post(backendUrl + config.backend.feeds.register, formData, {credentials: false, headers: {"XApiKey": config.backend.apiKey}})
          .then(function(resp) {
            console.log(resp);
            this.$emit('loaded');
            this.hasErrors = forms.showErrors(this.formData, formErrors);

            if (!this.hasErrors) {
              this.$router.push({ path: 'registration-success' });
            } else {
              this.flash(this.wordings['layout.userData1.form.errors'], 'errors');
            }
          })
          .catch(function(resp) {
            if (resp.body) {
              formErrors = Object.assign({}, formErrors, resp.body.errors);
            }
            this.$emit('loaded');
            this.hasErrors = forms.showErrors(this.formData, formErrors);

            if (!this.hasErrors) {
            } else {
              this.$refs.captcha.reset();
              this.flash(this.wordings['layout.userData1.form.error'], 'error');
            }

            if (resp.body.error) {
              this.flash(errorToHumanString(resp.body.error), 'error');
            }

            switch(resp.status) {
              case 500:
                this.flash(this.wordings['flashes.generalError'], 'error');
                break
              case 403:
                this.flash(this.wordings['flashes.registrationSeized'], 'error');
                break
              case 400:
                break
              case 200:
                this.$router.push({ path: 'registration-success' });
                break
              default:
                this.flash(this.wordings['flashes.generalError'], 'error');
            }
          });
        });
        // Edge has some problem with finally
        // .finally(function() {
        //   this.$emit('loaded');
        //   this.hasErrors = forms.showErrors(this.formData, formErrors);

        //   if (!this.hasErrors) {
        //     this.gotoNext();
        //   }
        // });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Registration.vue